(function() {
  'use strict';
  angular.module('benefits')
  .filter('deductible', function() {
    return function(data) {
      if(data === null) {
        return "N/A";
      } else {
        if(data) {
          return "Met";
        } else {
          return "Applies";
        }
      }
    };
  });
})();
